/* Raw Water Co. v2 — Comparison tab toggle (chart <-> full-width image). */
(function () {
  function init(section) {
    if (section.dataset.v2Init) return;
    section.dataset.v2Init = "1";
    var tabs = section.querySelectorAll("[data-v2-cmp-tab]");
    var views = section.querySelectorAll("[data-v2-cmp-view]");
    if (!tabs.length) return;

    function show(which) {
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-v2-cmp-tab") === which;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      views.forEach(function (v) {
        var on = v.getAttribute("data-v2-cmp-view") === which;
        v.classList.toggle("is-active", on);
        v.hidden = !on;
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener("click", function () { show(t.getAttribute("data-v2-cmp-tab")); });
    });
  }

  function initAll() { document.querySelectorAll("[data-v2-compare]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
